// src/components/3DModelling/MaterialSelector.js
import React from 'react';

const MaterialSelector = ({ label, mesh, allowedMaterials, currentMaterial, onChange }) => {
  return (
    <div style={{ marginBottom: '10px' }}>
      <label htmlFor={`${mesh.name}-material`} style={{ display: 'block', marginBottom: '5px' }}>
        {label}:
      </label>
      <select
        id={`${mesh.name}-material`}
        value={currentMaterial || ''}
        onChange={(e) => onChange(mesh, e.target.value)}
        style={{
          width: '100%',
          padding: '6px',
          fontSize: '14px',
          borderRadius: '4px',
          border: '1px solid #ccc'
        }}
      >
        <option value="" disabled>Select Material</option>
        {allowedMaterials.map((mat, index) => (
          <option key={index} value={mat}>{mat}</option>
        ))}
      </select>
    </div>
  );
};

export default MaterialSelector;
